import { Component } from "solid-js";

interface GroceryIconProps {
  class?: string;
}

export const GroceryIcon: Component<GroceryIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3689 10.1372H20.8406C24.0733 10.1372 26.6939 12.7578 26.6939 15.9905V23.0145C26.6939 26.2471 24.0733 28.8677 20.8406 28.8677H11.3689C8.19503 28.8677 5.62207 26.2948 5.62207 23.1209V15.8841C5.62207 12.7102 8.19503 10.1372 11.3689 10.1372Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2991 9.27703C12.2991 7.19801 13.9845 5.51263 16.0635 5.51263C18.1425 5.51263 19.8279 7.19801 19.8279 9.27703"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0636 5.5127C16.0633 3.60585 14.6375 2.00028 12.744 1.77474C10.8505 1.54919 9.08741 2.77489 8.63924 4.62833C8.59734 4.80275 8.47913 4.94904 8.31738 5.02661C8.15564 5.10419 7.96756 5.10481 7.80531 5.02829C6.83317 4.63383 5.71771 4.97877 5.13793 5.85313C4.55815 6.72749 4.67454 7.88925 5.41625 8.63123L7.10267 10.2905"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4367 10.7224C26.85 9.27717 27.2275 7.36333 27.2295 6.10018V5.3473C27.2295 4.9315 26.8924 4.59442 26.4766 4.59442H25.7236C22.9168 4.59717 20.4847 6.54021 19.8623 9.27717"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0122 14.4761C11.0122 17.3181 13.3161 19.622 16.1581 19.622C19.0001 19.622 21.304 17.3181 21.304 14.4761"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
